var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"display-block"},[_c('div',{staticClass:"widget"},[_c('h2',{staticStyle:{"margin-top":"0px"}},[_vm._v("Issues")]),_c('div')])])}]

export { render, staticRenderFns }